import { OrgLogo } from "@hulahoop/ui";

export function ShellOrganizationMark({
  name,
  logoUrl,
  size,
}: {
  name: string;
  logoUrl?: string | null;
  size?: "sm" | "md" | "xl";
}) {
  if (logoUrl) {
    return (
      <OrgLogo size={size} className="overflow-hidden">
        <img src={logoUrl} alt="" className="size-full object-cover" />
      </OrgLogo>
    );
  }
  return <OrgLogo size={size}>{name.slice(0, 1)}</OrgLogo>;
}
